import { Component, inject, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { CustomerType } from '../../../models/client-configuration';
import { ConfigService } from '../../../services/config.service';
import { combineLatest, map } from 'rxjs';
import { SearchesFacade } from 'src/app/state/user/searches/searches.facade';
import { SearchModel } from 'src/app/models/search-model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-searches',
  templateUrl: './user-searches.component.html',
  styleUrls: ['./user-searches.component.scss'],
})
export class UserSearchesComponent implements OnInit {
  section = 'search';

  userService: UserService;
  customerType: CustomerType;

  readonly searchHistory$ = this.searchesFacade.searchHistory$;
  readonly savedSearches$ = this.searchesFacade.savedSearches$;
  readonly isLoading$ = this.searchesFacade.isLoading$;

  private readonly router = inject(Router);

  readonly emptySearches$ = combineLatest([
    this.searchHistory$,
    this.savedSearches$
  ]).pipe(
    map(([searchHistory, savedSearches]) => {
      return !searchHistory.length && !savedSearches.length;
    })
  );

  constructor(
    userService: UserService,
    private configService: ConfigService,
    private searchesFacade: SearchesFacade
  ) {
    this.userService = userService;
  }

  ngOnInit() {
    this.searchesFacade.getHistoryAndSavedSearches().subscribe();
    this.customerType = this.configService.customerType;
  }

  explore() {
    const model = new SearchModel();
    model.explore = true;

    this.router.navigate(['/results'], {
      queryParams: model.toRequest(),
    });
  }
}
